import React from 'react'
import styled from 'styled-components'
import Content from './Content'

const OuterContainer = styled.div`
  overflow: hidden;
  position: relative;
`

const Container = styled.div`
  font-size: 26px;
  line-height: 38px;
  padding: ${(props) => (props.flipped ? '80px 0' : '40px 0')};
  text-align: ${(props) => (props.flipped ? 'center' : 'left')};
  display: flex;
  justify-content: ${(props) => (props.flipped ? 'flex-end' : 'flex-start')};
  position: relative;
  max-width: 1360px;
  overflow: hidden;
  margin: 0 auto;

  @media (min-width: 960px) {
    padding: ${(props) => (props.flipped ? '100px 0' : '60px 0')};
    text-align: ${(props) => (props.flipped ? 'right' : 'left')};
    overflow-x: visible;
  }
`

const Inner = styled.div`
  position: relative;
  z-index: 1;

  .button-wrapper {
    display: flex;
    justify-content: ${(props) => (props.flipped ? 'flex-end' : 'flex-start')};
  }

  @media (min-width: 960px) {
    padding: 0 20px;
    p,
    h3,
    h2 {
      width: ${(props) => (props.flipped ? '60%' : '50%')};
      display: ${(props) => (props.flipped ? 'inline-block' : 'block')};
    }
  }
`

const CtaBlock = ({ children, flipped, otherChildren }) => {
  return (
    <OuterContainer>
      <Container flipped={flipped}>
        <Inner flipped={flipped}>
          <Content>{children}</Content>
        </Inner>
      </Container>
      {otherChildren}
    </OuterContainer>
  )
}

export default CtaBlock
